import { User } from 'firebase/auth';
import { useContext } from 'react';
import { AuthContext } from '../context/authContext';

export const useUser = (): User | null => {
  return useContext(AuthContext)?.user || null;
};
